/**
 * @module FE-CU28_ニックネーム設定画面_カメラ
 */
import Header from '../../../components/header/Header.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import ListPanel from '../../../components/listPanel/ListPanel.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU28';

export default {
  name: 'Nickname',
  components: {
    Header,
    BreadCrumbList,
    MobileFooter,
    ListPanel,
    PcPageTitle,
    PCFooter,
  },
  data(vm) {
    return {
      pcTitle: vm.$vuetify.lang.t('$vuetify.FECU28ニックネーム設定画面カメラ.ニックネーム設定'), //"ニックネーム設定",
      spTitle: vm.$vuetify.lang.t('$vuetify.FECU28ニックネーム設定画面カメラ.spTitle'), // "ニックネーム設定(カメラ)",
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU28ニックネーム設定画面カメラ.C0001'
      ),
      //"カメラのニックネーム変更を行うことができます。\nニックネームは、カメラの一覧や通知履歴等に表示されます。",
      isActive: false,
      isValid: true,
      displayPanelTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      displayAreaList: [],
      nickName: '',
      modified: '',
      nickNameError: '',
      CONSTANTS: CONSTANTS,
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    nickNameRule() {
      return [
        !!this.nickName ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU28ニックネーム設定画面カメラ.E0001'),
      ];
    },
    i18nItems(vm) {
      return {
        pcTitle: vm.$vuetify.lang.t('$vuetify.FECU28ニックネーム設定画面カメラ.ニックネーム設定'), //"ニックネーム設定",
        spTitle: vm.$vuetify.lang.t('$vuetify.FECU28ニックネーム設定画面カメラ.spTitle'), // "ニックネーム設定(カメラ)",
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU28ニックネーム設定画面カメラ.C0001'
        ),
        //"カメラのニックネーム変更を行うことができます。\nニックネームは、カメラの一覧や通知履歴等に表示されます。",
        displayPanelTitle: {
          place: '',
          type: '$vuetify.FECU28ニックネーム設定画面カメラ.カメラ',
          typeIsBefore: false,
        },
      };
    },
    /**
     * 設定ボタン活性制御
     */
    checkValid() {
      if (this.isValid && this.nickName != '') {
        return false;
      }
      return true;
    },
  },
  /** @type {Methods} */
  methods: {
    active: function () {
      this.isActive = !this.isActive;
    },
    updateGender() {
      this.firstAidInfoList[this.personId - 1].gender = this.gender;
    },
    /**
     * カメラ情報設定データ取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU2801: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     cameraInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //       cameraNickName: "リビングカメラ",
            //       deviceID: "1111",
            //       modified: "2022-05-02 17:00:00",
            //     },
            //   },
            // };

            const targetItem = apiData.contentsInfo.cameraInfo;
            const labels = {
              usagePlan: '$vuetify.FECU28ニックネーム設定画面カメラ.カメラ詳細表示領域.利用プラン', //"利用プラン",
              customerNumber:
                '$vuetify.FECU28ニックネーム設定画面カメラ.カメラ詳細表示領域.お客様番号', // "お客様番号",
              securityDestinationName:
                '$vuetify.FECU28ニックネーム設定画面カメラ.カメラ詳細表示領域.警備先名', // "警備先名",
              districtSplitNumber:
                '$vuetify.FECU28ニックネーム設定画面カメラ.カメラ詳細表示領域.地区番号', // "地区番号",
              districtSplitName:
                '$vuetify.FECU28ニックネーム設定画面カメラ.カメラ詳細表示領域.地区名', // "地区名",
              displayDistrictNickname:
                '$vuetify.FECU28ニックネーム設定画面カメラ.カメラ詳細表示領域.ニックネーム地区表示', //"ニックネーム(対象地区)",
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
            ];
            const planTitles = {
              [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
            };

            Object.keys(targetItem).map((key, index) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '') {
                    return;
                  }
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU28ニックネーム設定画面カメラ.メイン地区';
                  }
                }
                this.displayAreaList = [
                  ...this.displayAreaList,
                  {
                    id: index,
                    title: labels[key],
                    text: text,
                    isVuetifyKey: text?.includes('$'),
                  },
                ];
              }
            });

            // 取得したデータをマッピングする
            this.nickName = apiData.contentsInfo.cameraInfo.cameraNickName;
            this.displayPanelTitle = {
              place: `- ${apiData.contentsInfo.cameraInfo.cameraNickName} `,
              type: '$vuetify.FECU28ニックネーム設定画面カメラ.カメラ',
              typeIsBefore: true,
            };

            this.modified = apiData.contentsInfo.modified;
          },
          (error /* eslint-disable-line */) => {
            if (error.message.includes('403')) {
              this.$router.replace({
                path: '/top',
              });
            } else {
              this.isValid = false;
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * カメラニックネーム設定API実行処理
     */
    APP_CU2802: function () {
      this.$_setLoading(true);

      let param = '/api/setCameraNickname/setNickname';
      // let param = "post";
      let method = 'post';

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
        cameraNickname: this.nickName,
        modified: this.modified,
      };

      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // レスポンスなし
            this.$informationDialog(
              '$vuetify.メッセージ一覧.FECU28ニックネーム設定画面カメラ.C0003',
              false,
              true
            );
          },
          (error /* eslint-disable-line */) => {
            if (error.message.includes('400')) {
              // エラーダイアログを表示
              this.$errorDialog('$vuetify.メッセージ一覧.FECU28ニックネーム設定画面カメラ.E0004');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return;
    },
    /**
     * 設定ボタン押下時処理
     * 確認ダイアログを表示してカメラニックネーム設定APIを実行
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU28ニックネーム設定画面カメラ.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
        // "確認",
        // "入力された内容で登録します。\n\rよろしいでしょうか。",
        // "いいえ",
        // "はい"
      );
      if (result === true) {
        // はいを押すと更新処理実行
        this.APP_CU2802();
      }
    },
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //何故か、以下通信でローディングマークを出してるので、ここで画面表示
    this.isShowPage = true;

    let param = '/api/setCameraNickname/init';

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      deviceID: this.$store.state.deviceID,
    };

    let method = 'post';

    // APP_CU2801
    await this.APP_CU2801(param, queries, method);
  },
};
